import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './Style/AppNavbar.css';

const AppNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/admin/login');
  };

  const goToLeadPage = () => navigate('/Leadpage');
  const goToProjectDetails = () => navigate('/ProjectDetails');

  return (
    <Navbar bg="dark" variant="dark" expand="lg" fixed="top" className="custom-navbar">
      <Container>
        <Navbar.Brand onClick={() => navigate('/')} style={{ cursor: 'pointer' }} className="text-white">
          <span className="navbar-logo"></span>
          <span className="brand-text">YTC TechVentures</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link onClick={goToLeadPage} className="text-white">
              Lead Details
            </Nav.Link>
            <Nav.Link onClick={goToProjectDetails} className="text-white">
              Project Details
            </Nav.Link>
          </Nav>
          <Button variant="outline-light" onClick={handleLogout} className="ms-3">
            Logout
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
